module.exports = __webpack_public_path__ + "static/media/call30.d146587e.png";